import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_SENTRY_ENV,
  integrations: [new BrowserTracing() /* , new Sentry.Replay() */],
  tracesSampleRate: 0.1,
  sendDefaultPii: true,
  ignoreErrors: [
    // Google translate
    /evaluating 'a.L'/,
    // Blocked scripts
    /Non-Error exception captured/,
    /Non-Error promise rejection captured/,
    // Redirect in Safari
    /Can`t resolve mutation/,
    // Cancelled promise
    /TypeError: cancelled/,
    // COM
    /\$ is not defined/,
    /GoogleTrackingAdapter is not defined/,
    // Onboarding video loading
    /The play\(\) request was interrupted by a call to pause\(\)/,
  ],
  denyUrls: [
    // Hotjar
    /in\.hotjar\.com/i,
    /script\.hotjar\.com/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    /chrome-extension:\/\//i,
    // Zendesk
    /static\.zdassets\.com/i,
    // Intercom
    /js\.intercomcdn\.com/i,
  ],
});

export default Sentry;
